import React from 'react';
import { GoStarFill } from 'react-icons/go';

const Rating = ({ number }) => {
  return (
    <div className="flex gap-2">
      {[1, 2, 3, 4, 5].map((item, index) => (
        <GoStarFill
          size={18}
          key={index}
          className={index < number ? 'text-yellow-400' : 'text-gray-700'}
        />
      ))}
    </div>
  );
};

export default Rating;
